import type { FC } from 'react';
import { memo } from 'react';
import classNames from 'classnames';
import { IlistItem } from '@/utils/ctype';
import { IparsingAI, IplayAudio } from '@/utils/audioPlay';
import style from '../DragAI/index.module.less';
import SpeechBtn from '../SpeechBtn';
import Analysis from '../Analysis';
import { ErrorSvg, CorrectSvg } from '../../Svg';
import HtmlParser from '../HtmlParser';

interface IProp {
  data: IlistItem; 
  type: string; 
  answer: string; 
  parsingAI: IparsingAI; 
  playAudio: IplayAudio; 
  isListen?: boolean; 
  blankClass?: string; 
  dataKey: string; 
  answerKey: string; 
  blankBoxClass?: string;
  id: string;
}

export const Drop: FC<IProp> = memo(function Drop(props) {
  const {data, type, answer, parsingAI, playAudio, isListen, blankClass, dataKey, answerKey, blankBoxClass, id} = props;

  const {display_answerHtml} = data;
  
  return (
    <div data-testid="dustbin" className={classNames(style.blank, blankBoxClass)} id={id}>
      <div className={classNames(style.blankBox, style[type], blankClass)} data-key={answerKey}><HtmlParser htmlString={answer}></HtmlParser><i className={style.icon}>{type === 'success' ? CorrectSvg() : ErrorSvg()}</i></div>
      <span className={style.answer} data-key={dataKey}><HtmlParser htmlString={display_answerHtml}></HtmlParser></span>
      {isListen ? <SpeechBtn onClick={playAudio} index={data.number}></SpeechBtn> : null}
      <Analysis className={style.mt15} onClick={parsingAI}></Analysis>
    </div>
  );
});

export default Drop;